module.exports = __webpack_public_path__ + "img/qdt@2x.72fad0e6.png";